<template>
  <v-dialog v-model="isActive" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>

    <v-overlay v-if="isLoading" absolute color="#48B38B">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-card>
      <div class="header">
        <div class="content-header">
          <div @click="close()" class="return-screen">
            <v-icon color="white">mdi-close</v-icon>
          </div>
          <div @click="handleAddCondition()" class="add-screen mr-3">
            <v-icon color="primary">mdi-plus</v-icon>
          </div>
          <h2>Condições de Pagamento</h2>
          <div>Atrelar condições de pagamento ao orçamento selecionado</div>
        </div>
      </div>
      <div class="content">
        <v-alert
          class="mx-4 my-4"
          dense
          color="grey lighten-2"
          icon="mdi-information-outline"
        >
          <div class="text-caption text--secondary">Selecione as opções que serão apresentadas no orçamento do cliente.</div>
        </v-alert>
        <v-list
          class="mx-auto"
        >
          <v-list-item v-for="condition in localConditions" :key="condition.id">
            <v-list-item-action>
              <v-icon>mdi-clock-outline</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{ condition.description }}</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-switch
                v-model="selectedConditions"
                color="primary"
                hide-details
                :value="condition.id"
                @change="handlePaymentConditionChange(condition.id)"
              ></v-switch>
            </v-list-item-action>

            <v-list-item-action>
              <v-btn icon @click="handleEditCondition(condition)">
                <v-icon color="primary">mdi-dots-vertical</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </div>
    </v-card>

    <v-bottom-sheet v-model="isAddPaymentCondition" persistent>
      <div class="bottom-sheet-content">
        <div class="bottom-sheet-header">
          <span class="bottom-sheet-title">{{ modalPrefix }} condição</span>
          <v-btn icon @click="closeManageModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <v-text-field v-model="description" class="py-4" label="Condição de Pagamento" outlined></v-text-field>
        <v-btn color="primary" block @click="managePaymentCondition" :disabled="!description">Salvar</v-btn>
        <v-btn v-if="isEditPaymentCondition" class="mt-4" color="red" outlined block @click="isRemoveDialogActive = true">Excluir</v-btn>
      </div>
    </v-bottom-sheet>

    <v-dialog
      v-model="isRemoveDialogActive"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          Remover condição
        </v-card-title>
        <v-card-text>
          Tem certeza que deseja remover esta condição de pagamento?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="isRemoveDialogActive = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="removeCondition"
          >
            Remover
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

import BudgetPaymentConditionsService from '@/services/api/budgetPaymentConditions';
import PaymentConditionsService from '@/services/api/paymentCondition';

export default {
  name: 'PaymentCondition',
  emits: ['close'],
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    conditions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      isAddPaymentCondition: false,
      isEditPaymentCondition: false,
      isRemoveDialogActive: false,
      description: '',
      selectedConditions: [],
      selectedCondition: null,
      localConditions: [],
    };
  },
  computed: {
    ...mapState('Budget', ['selectedBudget']),
    modalPrefix() {
      return this.selectedCondition ? 'Editar' : 'Nova';
    },
  },
  created() {
    const conditions = this.selectedBudget.budget_payment_conditions;

    this.selectedConditions = conditions ? conditions.map((condition) => condition.payment_condition_id) : [];

    this.localConditions = [...this.conditions];
  },
  methods: {
    close() {
      this.$emit('close');
    },
    handlePaymentConditionChange(conditionId) {
      this.isLoading = true;

      const unstructuredConditions = { ...this.selectedConditions };
      const conditions = Object.values(unstructuredConditions);

      const promise = conditions.includes(conditionId) ? BudgetPaymentConditionsService.create({ budget_id: this.selectedBudget.id, payment_condition_id: conditionId }) : BudgetPaymentConditionsService.inactivate(this.selectedBudget.id, conditionId)

      promise
        .then(() => {
          this.isLoading = false;

          const condition = {
            payment_condition_id: conditionId,
            description: this.localConditions.find((condition) => condition.id === conditionId).description,
          };

          const action = conditions.includes(conditionId) ? 'ADD_PAYMENT_CONDITION' : 'REMOVE_PAYMENT_CONDITION';

          this.$store.commit('Budget/MANAGE_PAYMENT_CONDITIONS', { condition, action });
        });
    },
    handleAddCondition() {
      this.description = '';
      this.isAddPaymentCondition = true;
    },
    handleEditCondition(condition) {
      this.selectedCondition = condition;
      this.description = condition.description;
      this.isAddPaymentCondition = true;
      this.isEditPaymentCondition = true;
    },
    removeCondition() {
      this.isLoading = true;
      this.isRemoveDialogActive = false;

      this.closeManageModal();

      PaymentConditionsService.inactivate(this.selectedCondition.id)
        .then(() => {
          this.localConditions = this.localConditions.filter((condition) => condition.id !== this.selectedCondition.id);
          this.isLoading = false;

          const condition = {
            payment_condition_id: this.selectedCondition.id,
            description: this.selectedCondition.description,
          };

          this.$store.commit('Budget/MANAGE_PAYMENT_CONDITIONS', { condition, action: 'REMOVE_PAYMENT_CONDITION' });

          this.selectedCondition = null;
        });
    },
    managePaymentCondition() {
      this.isLoading = true;
      this.isAddPaymentCondition = false;

      const promise = this.isEditPaymentCondition
        ? PaymentConditionsService.update(this.selectedCondition.id, { description: this.description })
        : PaymentConditionsService.create({ description: this.description });

        promise
          .then((response) => {
            if (this.isEditPaymentCondition) {
              this.localConditions = this.localConditions.map((condition) => {
                if (condition.id === response.data.id) {
                  return response.data;
                }

                return condition;
              });

              this.closeManageModal();
              this.selectedCondition = null;
            } else {
              BudgetPaymentConditionsService.create({ budget_id: this.selectedBudget.id, payment_condition_id: response.data.id });

              this.localConditions.push(response.data);
              this.selectedConditions.push(response.data.id);
            }

            const condition = {
              payment_condition_id: response.data.id,
              description: response.data.description,
            };

            this.$store.commit('Budget/MANAGE_PAYMENT_CONDITIONS', { condition, action: 'ADD_PAYMENT_CONDITION'});

            this.isLoading = false;
          });
    },
    closeManageModal() {
      this.isAddPaymentCondition = false;
      this.isEditPaymentCondition = false;
      this.description = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  z-index: 999;
  border-radius: 0px !important;

  .content-header {
    padding: 20px 20px;
    background-color: #3e515f;
    color: #fff;

    .return-screen {
      float: right;
      background-color: #2d3c47;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
    }

    .add-screen {
      float: right;
      background-color: white;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
    }
  }
}

.bottom-sheet-content {
  padding: 16px;

  .bottom-sheet-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .bottom-sheet-title {
      font-size: 18px;
      font-weight: 500;
    }
  }
}
</style>
